export enum BUTTON_SIZES {
  sm = 'sm',
  md = 'md',
  lg = 'lg',
  none = '',
}

export enum BUTTON_STYLES {
  primary = 'Primary',
  secondary = 'Secondary',
  link = 'Link',
}

export const BUTTON_SIZE_CLASSES = {
  [BUTTON_SIZES.sm]: 'btn-sm',
  [BUTTON_SIZES.md]: 'btn-md',
  [BUTTON_SIZES.lg]: 'btn-lg',
  [BUTTON_SIZES.none]: '',
};

export const BUTTON_STYLE_CLASSES = {
  [BUTTON_STYLES.primary]: 'btn btn-primary',
  [BUTTON_STYLES.secondary]: 'btn btn-secondary',
  [BUTTON_STYLES.link]: 'text-blue-deep hover:text-blue-deep-hover underline',
};
